"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TemplateType;
(function (TemplateType) {
    TemplateType[TemplateType["Anamnese"] = 0] = "Anamnese";
    TemplateType[TemplateType["Folgevisite"] = 1] = "Folgevisite";
    TemplateType[TemplateType["Schulungsprotokoll"] = 2] = "Schulungsprotokoll";
    TemplateType[TemplateType["\u00C4rztlicheDelegation"] = 3] = "\u00C4rztlicheDelegation";
    TemplateType[TemplateType["Kosten\u00FCbernahme"] = 4] = "Kosten\u00FCbernahme";
})(TemplateType = exports.TemplateType || (exports.TemplateType = {}));
